import { memo } from 'react';
import Image from 'next/image';

import { FTFCompanyDetailItem } from '~/types/product';

export default memo(function FTFCompanyDetailItem({
  item,
}: Readonly<{ item: FTFCompanyDetailItem }>) {
  return (
    <div className="flex flex-col gap-1" data-testid="ftf-company-detail-item">
      <div className="flex items-center">
        <Image
          src={item.icon}
          alt={item.label}
          width={20}
          height={20}
          className="mr-2 inline-block h-5 w-5"
        />
        <span className="font-bold">{item.label}</span>
      </div>
      {item.content}
    </div>
  );
});
